import { getDashboardEmissions } from '../../../api/emissionsApi';
import { getHistoricalReports } from '../../../api/historicalReportsApi';
import { createEmptyDashboard, normalizeDashboard, normalizeHistoricalDashboard } from '../model/emissionScreens';
import useEmissionScreen from './useEmissionScreen';

const requestHistoricalDashboard = (_fiscalYear, config) => getHistoricalReports(config);

export default function useDashboardEmissions() {
  return useEmissionScreen({
    request: getDashboardEmissions,
    normalize: normalizeDashboard,
    createEmpty: createEmptyDashboard,
    historicalRequest: requestHistoricalDashboard,
    normalizeHistorical: normalizeHistoricalDashboard,
  });
}
